/*
 * art-menu-hover-guard — additive, SHOP-NEUTRALE Korrektur von Horizons Mega-Menü.
 * Wird nur geladen, wenn die Theme-Einstellung „Navigation: Mega-Menü öffnet zuverlässig"
 * (`art_menu_hover_guard`) aktiv ist. Ändert weder Horizons Dateien noch Markup oder Stil.
 *
 * Horizon schließt das Mega-Menü bei JEDEM `pointerleave` am Listenpunkt, und zwar sofort
 * (`on:pointerleave="/deactivate"` in blocks/_header-menu.liquid, `deactivate` in
 * assets/header-menu.js, ohne Verzögerung). Chrome meldet dort aber auch Verlassen, die keine
 * sind: Horizons Hover-Brücke unter jedem Menüpunkt ist ein Pseudo-Element
 * (`.menu-list__list-item::after`), und Chrome schickt dessen Betreten und Verlassen an den
 * Listenpunkt. Wechselt der Zeiger vom Streifen unter dem Wort auf das Wort oder ins Panel, kommt
 * ein `pointerleave` an, obwohl der Zeiger den Punkt nie verlassen hat, und das Menü klappt zu.
 * Gemessen auch mit stillgelegtem Horizon-Skript, also reine Browser-Ereignisse: beim Eintreten
 * zweimal `pointerenter`, beim Wechsel Streifen → Wort `pointerleave` mit dem eigenen Link als
 * `relatedTarget`. Sichtbar als „geht nicht auf" (von unten angefahren) und „geht sofort wieder
 * zu" (Flackern, solange der Zeiger um den Streifen pendelt).
 *
 * Abhilfe: vor dem Schließen nachsehen, ob der Zeiger wirklich draußen ist (Treffertest an der
 * Zeigerposition). Steht er noch im Listenpunkt (Wort, Brücke, offenes Panel), war die Meldung
 * falsch, und das Menü bleibt offen. Echte Wechsel laufen unverändert durch Horizon: Zeiger
 * außerhalb, Fokusverlust (`blur`) und Berührung (`pointerType` touch).
 *
 * Teil 2 unter demselben Schalter steht in snippets/art-globals.liquid: Während Horizons
 * Vorhang-Animation (`clip-path`-Transition, rund 350 ms) ist das Panel für den Zeiger nicht
 * vorhanden, wer zügig hineinfährt, verlässt den Listenpunkt WIRKLICH. Dort liegt deshalb eine
 * unsichtbare Fangfläche des Listenpunkts (`::before`) unter dem Panel. Auch sie ist ein
 * Pseudo-Element; ihre Falschmeldungen fängt dieses Skript ab, beide Teile gehören zusammen.
 *
 * Verworfen, weil jede Variante die Optik verschob: die Brücke als Innenabstand des Listenpunkts
 * (`overflow-list` misst den Punkt beim Laden und schreibt die Höhe fest: Kopf 11 px höher), als
 * Innenabstand des Links (Fokusrahmen 11 px höher) und als Pseudo-Element des Links (die
 * automatischen Außenränder runden 1/64 px anders als Horizons Zentrierung: Schrift 1 px tiefer).
 */
(function () {
  function guard(HeaderMenu) {
    var proto = HeaderMenu && HeaderMenu.prototype;
    if (!proto || typeof proto.deactivate !== 'function' || proto.deactivate.artHoverGuard) return;

    var deactivate = proto.deactivate;
    var guarded = function (event) {
      if (
        event &&
        event.type === 'pointerleave' &&
        event.pointerType !== 'touch' &&
        event.target instanceof Element
      ) {
        var hit = document.elementFromPoint(event.clientX, event.clientY);
        if (hit && event.target.contains(hit)) return;
      }
      return deactivate.apply(this, arguments);
    };
    guarded.artHoverGuard = true;
    proto.deactivate = guarded;
  }

  if (typeof customElements === 'undefined') return;
  var HeaderMenu = customElements.get('header-menu');
  if (HeaderMenu) {
    guard(HeaderMenu);
  } else {
    customElements.whenDefined('header-menu').then(function () {
      guard(customElements.get('header-menu'));
    });
  }
})();
